import React, { lazy, useEffect } from "react";
import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
} from "react-router-dom";
import "./App.css";
import { useSelector } from "react-redux";
import Loader from "./CommonComponets/Loader";
import Login from "./CommonComponets/Login/login.jsx";
import PrivateRoute from "./Routes/Private/PrivateRoute";
import DashboardToggle from "./Pages/Toggle/Toggle";
import DashboardBisiness from "./Projects/AssociatePanel/Pages/Dashboard";
import OtpVerification from "./CommonComponets/OtpVerification/OtpVerification";
import ForgetPassword from "./CommonComponets/GetPassword/ForgetPassword";
import ChangePassword from "./CommonComponets/ChangePassword/ChangePassword";
import MyPayoutDetailOrg from "./Projects/OrgEcommerce/Pages/BusinessArea/MyPayoutDetails.jsx";
import MyPayoutsOrg from "./Projects/OrgEcommerce/Pages/BusinessArea/MyPayouts.jsx";
import CenteredSettings from "./CommonComponets/Settings.jsx";
import ChangePasswordForm from "./Projects/AssociatePanel/componets/changePassword/ChangePassword.jsx";
import MyRankOrg from "./Projects/OrgEcommerce/Pages/TeamArea/MyRank/MyRank.jsx";
import UserList from "./Projects/OrgEcommerce/Componets/UserList/UserList.js";
import OrganicWrapper from "./Projects/OrgEcommerce/Componets/OrganicWrapper/OrganicWrapper.js";
// Property Bussiness
const MyWallets = lazy(
  () => import("./Projects/AssociatePanel/Pages/MyWallets/MyWallets"),
);
const TeamTeeeView = lazy(
  () => import("./Projects/AssociatePanel/Pages/TeamTreeView/TeamTreeView"),
);
const Profile = lazy(
  () => import("./Projects/AssociatePanel/Pages/Profile/Profile"),
);
const BussinessCustomerList = lazy(
  () =>
    import("./Projects/AssociatePanel/Pages/CustomerArea/BussinessCustomerList/BussinessCustomerList"),
);
const CustomerDetails = lazy(
  () =>
    import("./Projects/AssociatePanel/Pages/CustomerArea/BussinessCustomerDetails/BussinessCustomerDetails"),
);
const AddAssociate = lazy(
  () =>
    import("./Projects/AssociatePanel/Pages/TeamArea/Associate/AddAssociate"),
);
const AddCustomer = lazy(
  () =>
    import("./Projects/AssociatePanel/Pages/CustomerArea/AddCustomer/AddCustomer"),
);
const RequestSiteVisit = lazy(
  () =>
    import("./Projects/AssociatePanel/Pages/SiteVisitArea/RequestSiteVisit/RequestSiteVisit"),
);
const CreateSupportTicket = lazy(
  () =>
    import("./Projects/AssociatePanel/Pages/SupportTicketArea/CreateSupportTicket"),
);
const RecursiveBusiness = lazy(
  () =>
    import("./Projects/AssociatePanel/Pages/MyReport/MyBusiness/MyBussinessRecussive"),
);
const FindPlot = lazy(
  () =>
    import("./Projects/AssociatePanel/Pages/CustomerArea/FindPlot/FindPlot"),
);
const SiteVisitList = lazy(
  () =>
    import("./Projects/AssociatePanel/Pages/SiteVisitArea/SiteVisitList/SiteVisitList"),
);
const SupportTicketlists = lazy(
  () =>
    import("./Projects/AssociatePanel/Pages/SupportTicketArea/SupportTicketList/SupportTicketlists"),
);
const MySponsorLine = lazy(
  () =>
    import("./Projects/AssociatePanel/Pages/TeamArea/MySponsorLine/MySponsorLine"),
);
const TeamLevelView = lazy(
  () =>
    import("./Projects/AssociatePanel/Pages/TeamTreeLevelView/TeamlevelView"),
);
const MyHoldPlotLists = lazy(
  () =>
    import("./Projects/AssociatePanel/Pages/CustomerArea/MyHoldPlotLists/MyHoldPlotLists"),
);
const Withdrallists = lazy(
  () => import("./Projects/AssociatePanel/Pages/BusinessArea/Withdrallists"),
);
const BookedPlotList = lazy(
  () =>
    import("./Projects/AssociatePanel/Pages/CustomerArea/bookedPlotLists/BookedPlotLists"),
);
const MyBusiness = lazy(
  () => import("./Projects/AssociatePanel/Pages/BusinessArea/myBusiness"),
);
const MyPayouts = lazy(
  () => import("./Projects/AssociatePanel/Pages/BusinessArea/MyPayouts"),
);
const TermsAndConditions = lazy(
  () =>
    import("./Projects/AssociatePanel/componets/TearmAndConditions/TearmAndConditions"),
);
const MyPayoutDetail = lazy(
  () => import("./Projects/AssociatePanel/Pages/BusinessArea/MyPayoutDetails"),
);
const ChatBox = lazy(
  () => import("./Projects/AssociatePanel/Pages/SupportTicketArea/chatBox"),
);
const MyPayoutReport = lazy(
  () =>
    import("./Projects/AssociatePanel/Pages/MyReport/MyPayoutReport/MyPayoutReport"),
);
const MyAnnualIncentive = lazy(
  () =>
    import("./Projects/AssociatePanel/Pages/MyReport/MyAnnualIncentive/MyAnnualIncentive"),
);
const MyFounderClub = lazy(
  () =>
    import("./Projects/AssociatePanel/Pages/MyReport/MyFounderClub/MyFounderClub"),
);
const MyGSTReport = lazy(
  () =>
    import("./Projects/AssociatePanel/Pages/MyReport/MyGSTReport/MyGSTReport"),
);
const MyTDSReport = lazy(
  () =>
    import("./Projects/AssociatePanel/Pages/MyReport/MyTDSReport/MyTDSReport"),
);
const HoldPLot = lazy(
  () =>
    import("./Projects/AssociatePanel/Pages/CustomerArea/MyHoldPlotLists/HoldPLot"),
);
const AddAssociateByRef = lazy(
  () =>
    import("./Projects/AssociatePanel/Pages/TeamArea/Associate/AssociateByRef/AddAssociateByRef"),
);
const WithdralReq = lazy(
  () => import("./Projects/AssociatePanel/Pages/BusinessArea/WithdralReq"),
);
const MyRank = lazy(
  () => import("./Projects/AssociatePanel/Pages/TeamArea/MyRank/MyRank"),
);
const ChatBoxOrg = lazy(
  () => import("./Projects/OrgEcommerce/Pages/SupportTicketArea/chatBox.jsx"),
);
const ProjectGallery = lazy(
  () => import("./Projects/AssociatePanel/Pages/Dashboard/ProjectGallery.jsx"),
);
// Org Ecommerce
const EcomCustomerList = lazy(
  () =>
    import("./Projects/OrgEcommerce/Pages/CustomerArea/BussinessCustomerList/BussinessCustomerList"),
);
const EcomAddCustomer = lazy(
  () =>
    import("./Projects/OrgEcommerce/Pages/CustomerArea/AddCustomer/AddCustomer"),
);
const EcomCustomerDetails = lazy(
  () =>
    import("./Projects/OrgEcommerce/Pages/CustomerArea/BussinessCustomerDetails/BussinessCustomerDetails"),
);
const EcomMy_wallets = lazy(
  () => import("./Projects/OrgEcommerce/Pages/MyWallets/MyWallets"),
);
const DashboardOrg = lazy(
  () => import("./Projects/OrgEcommerce/Pages/Dashboard"),
);
const ProfileOrg = lazy(
  () => import("./Projects/OrgEcommerce/Pages/Profile/Profile"),
);
const AddAssociateOrg = lazy(
  () => import("./Projects/OrgEcommerce/Pages/TeamArea/Associate/AddAssociate"),
);
const AddAssociateByRefOrg = lazy(
  () =>
    import("./Projects/OrgEcommerce/Pages/TeamArea/Associate/AssociateByRef/AddAssociateByRef"),
);
const CreateSupportTicketOrg = lazy(
  () =>
    import("./Projects/OrgEcommerce/Pages/SupportTicketArea/CreateSupportTicket"),
);
const SupportTicketListOrg = lazy(
  () =>
    import("./Projects/OrgEcommerce/Pages/SupportTicketArea/SupportTicketList/SupportTicketlists"),
);
const TeamTeeeViewOrg = lazy(
  () => import("./Projects/OrgEcommerce/Pages/TeamTreeView/TeamTreeView"),
);
const MySponsorLineOrg = lazy(
  () =>
    import("./Projects/OrgEcommerce/Pages/TeamArea/MySponsorLine/MySponsorLine"),
);
const MyPurchase = lazy(
  () =>
    import("./Projects/OrgEcommerce/Pages/CustomerArea/MyPurchase/MyPurchase"),
);
const MyBusinessOrg = lazy(
  () => import("./Projects/OrgEcommerce/Pages/BusinessArea/myBusiness"),
);
const WithdrallistsOrg = lazy(
  () => import("./Projects/OrgEcommerce/Pages/BusinessArea/Withdrallists.jsx"),
);
const WithdralReqOrg = lazy(
  () => import("./Projects/OrgEcommerce/Pages/BusinessArea/WithdralReq.jsx"),
);
const NotFoundPage = lazy(
  () => import("./CommonComponets/Page404/Page404.jsx"),
);
const RecursiveBusinessOrg = lazy(
  () =>
    import("./Projects/OrgEcommerce/Pages/MyReport/MyBusiness/MyBussinessRecussive/index.jsx"),
);
const MyPayoutReportOrg = lazy(
  () =>
    import("./Projects/OrgEcommerce/Pages/MyReport/MyPayoutReport/MyPayoutReport.jsx"),
);
const MyAnnualIncentiveOrg = lazy(
  () =>
    import("./Projects/OrgEcommerce/Pages/MyReport/MyAnnualIncentive/MyAnnualIncentive.jsx"),
);
const MyFounderClubOrg = lazy(
  () =>
    import("./Projects/OrgEcommerce/Pages/MyReport/MyFounderClub/MyFounderClub.jsx"),
);
const MyGSTReportOrg = lazy(
  () =>
    import("./Projects/OrgEcommerce/Pages/MyReport/MyGSTReport/MyGSTReport.jsx"),
);
const MyTDSReportOrg = lazy(
  () =>
    import("./Projects/OrgEcommerce/Pages/MyReport/MyTDSReport/MyTDSReport.jsx"),
);
const MyRewards = lazy(
  () =>
    import("./Projects/AssociatePanel/Pages/MyReport/MyRewards/MyRewards.jsx"),
);

const getRoutes = (appType) => {
  const isUserLoggedIn = sessionStorage.getItem("loggedInUser") || false;
  const commonRoutes = [
    {
      path: "/",
      element: <Navigate to={isUserLoggedIn ? "/dashboard" : "/login"} />,
    },
    {
      path: "/login",
      element: (
        <React.Suspense fallback={<Loader />}>
          <Login />
        </React.Suspense>
      ),
    },
    {
      path: "/switcher",
      element: <DashboardToggle />,
    },
    {
      path: "/otp-verification",
      element: <OtpVerification />,
    },
    {
      path: "/forget-password",
      element: <ForgetPassword />,
    },
    {
      path: "/change-password",
      element: <ChangePassword />,
    },
    {
      path: "/*",
      element: <NotFoundPage />,
    },
    {
      path: "/add-associate-by-referal",
      element: <AddAssociateByRefOrg />,
    },
  ];
  const ecommerceRoutes = [
    {
      path: "/profile",
      element: (
        <PrivateRoute>
          <ProfileOrg />
        </PrivateRoute>
      ),
    },
    {
      path: "/dashboard",
      element: (
        <PrivateRoute>
          <DashboardOrg />
        </PrivateRoute>
      ),
    },
    {
      path: "/customers-lists",
      element: (
        <PrivateRoute>
          <OrganicWrapper>
            <UserList />
          </OrganicWrapper>
        </PrivateRoute>
      ),
    },
    {
      path: "/add-customer",
      element: (
        <PrivateRoute>
          <EcomAddCustomer />
        </PrivateRoute>
      ),
    },
    {
      path: "/customers/customer-details",
      element: (
        <PrivateRoute>
          <EcomCustomerDetails />
        </PrivateRoute>
      ),
    },
    {
      path: "/my_wallets",
      element: (
        <PrivateRoute>
          <EcomMy_wallets />
        </PrivateRoute>
      ),
    },
    {
      path: "/add-new-associate",
      element: (
        <PrivateRoute>
          <OrganicWrapper>
            <AddAssociateOrg />
          </OrganicWrapper>
        </PrivateRoute>
      ),
    },
    {
      path: "/SupportTicketlists",
      element: (
        <PrivateRoute>
          <OrganicWrapper>
            <SupportTicketListOrg />
          </OrganicWrapper>
        </PrivateRoute>
      ),
    },
    {
      path: "/createSupportTicket",
      element: (
        <PrivateRoute>
          <CreateSupportTicketOrg />
        </PrivateRoute>
      ),
    },
    {
      path: "/chat",
      element: (
        <PrivateRoute>
          <ChatBoxOrg />
        </PrivateRoute>
      ),
    },
    {
      path: "/team-tree-view",
      element: (
        <PrivateRoute>
          <TeamTeeeViewOrg />
        </PrivateRoute>
      ),
    },
    {
      path: "/mySponsorLine",
      element: (
        <PrivateRoute>
          <OrganicWrapper>
            <MySponsorLineOrg />
          </OrganicWrapper>
        </PrivateRoute>
      ),
    },
    {
      path: "/My-Purchase",
      element: (
        <PrivateRoute>
          <MyPurchase />
        </PrivateRoute>
      ),
    },
    {
      path: "/MyBusiness",
      element: (
        <OrganicWrapper>
          <PrivateRoute>
            <MyBusinessOrg />
          </PrivateRoute>
        </OrganicWrapper>
      ),
    },
    {
      path: "/withdrawal-list",
      element: (
        <PrivateRoute>
          <WithdrallistsOrg />
        </PrivateRoute>
      ),
    },
    {
      path: "/withdrawal_request",
      element: (
        <PrivateRoute>
          <WithdralReqOrg />
        </PrivateRoute>
      ),
    },
    {
      path: "/my_payouts",
      element: (
        <PrivateRoute>
          <OrganicWrapper>
            <MyPayoutsOrg />
          </OrganicWrapper>
        </PrivateRoute>
      ),
    },
    {
      path: "/my-rank",
      element: (
        <PrivateRoute>
          <OrganicWrapper>
            <MyRankOrg />
          </OrganicWrapper>
        </PrivateRoute>
      ),
    },
    {
      path: "/terms-conditions",
      element: (
        <>
          <TermsAndConditions />
        </>
      ),
    },
    {
      path: "/my-payouts/my-payout-detail",
      element: (
        <PrivateRoute>
          <MyPayoutDetailOrg />
        </PrivateRoute>
      ),
    },
    {
      path: "/business-detail",
      element: (
        <PrivateRoute>
          <RecursiveBusinessOrg />
        </PrivateRoute>
      ),
    },
    {
      path: "/payout-report",
      element: (
        <PrivateRoute>
          <OrganicWrapper>
            <MyPayoutReportOrg />
          </OrganicWrapper>
        </PrivateRoute>
      ),
    },
    {
      path: "/annual-incentive",
      element: (
        <PrivateRoute>
          <MyAnnualIncentiveOrg />
        </PrivateRoute>
      ),
    },
    {
      path: "/founder-club",
      element: (
        <PrivateRoute>
          <MyFounderClubOrg />
        </PrivateRoute>
      ),
    },
    {
      path: "/gst-report",
      element: (
        <PrivateRoute>
          <MyGSTReportOrg />
        </PrivateRoute>
      ),
    },
    {
      path: "/tds-report",
      element: (
        <PrivateRoute>
          <MyTDSReportOrg />
        </PrivateRoute>
      ),
    },
  ];
  const businessRoutes = [
    {
      path: "/profile",
      element: (
        <PrivateRoute>
          <Profile />
        </PrivateRoute>
      ),
    },
    {
      path: "/my-wallets",
      element: (
        <PrivateRoute>
          <MyWallets />
        </PrivateRoute>
      ),
    },
    {
      path: "/team-tree-view",
      element: (
        <PrivateRoute>
          <TeamTeeeView />
        </PrivateRoute>
      ),
    },
    {
      path: "/my-rank",
      element: (
        <PrivateRoute>
          <MyRank />
        </PrivateRoute>
      ),
    },
    {
      path: "/my-rewards",
      element: (
        <PrivateRoute>
          <MyRewards />
        </PrivateRoute>
      ),
    },
    {
      path: "/team-level-view",
      element: (
        <PrivateRoute>
          <TeamLevelView />
        </PrivateRoute>
      ),
    },

    // Customer Area
    {
      path: "/customers",
      element: (
        <PrivateRoute>
          <BussinessCustomerList />
        </PrivateRoute>
      ),
    },
    {
      path: "/bookings",
      element: (
        <PrivateRoute>
          <BookedPlotList />
        </PrivateRoute>
      ),
    },
    {
      path: "/find-plots",
      element: (
        <PrivateRoute>
          <FindPlot />
        </PrivateRoute>
      ),
    },
    {
      path: "/hold-list",
      element: (
        <PrivateRoute>
          <MyHoldPlotLists />
        </PrivateRoute>
      ),
    },
    {
      path: "/find-plots/hold-plot",
      element: (
        <PrivateRoute>
          <HoldPLot />
        </PrivateRoute>
      ),
    },
    {
      path: "/customers/addCustomer",
      element: (
        <PrivateRoute>
          <AddCustomer />
        </PrivateRoute>
      ),
    },
    {
      path: "/customers/customer-details",
      element: (
        <PrivateRoute>
          <CustomerDetails />
        </PrivateRoute>
      ),
    },
    // Team Area
    {
      path: "/new-associate",
      element: (
        <PrivateRoute>
          <AddAssociate />
        </PrivateRoute>
      ),
    },
    {
      path: "/sponsor-line",
      element: (
        <PrivateRoute>
          <MySponsorLine />
        </PrivateRoute>
      ),
    },
    {
      path: "/add-associate-by-ref",
      element: (
        <>
          <AddAssociateByRef />
        </>
      ),
    },
    // Business Area
    {
      path: "/my-business",
      element: (
        <PrivateRoute>
          <MyBusiness />
        </PrivateRoute>
      ),
    },
    {
      path: "/withdrawal-request",
      element: (
        <PrivateRoute>
          <WithdralReq />
        </PrivateRoute>
      ),
    },
    {
      path: "/withdrawal-list",
      element: (
        <PrivateRoute>
          <Withdrallists />
        </PrivateRoute>
      ),
    },
    {
      path: "/my-payouts",
      element: (
        <PrivateRoute>
          <MyPayouts />
        </PrivateRoute>
      ),
    },
    {
      path: "/my-payouts/my-payout-detail",
      element: (
        <PrivateRoute>
          <MyPayoutDetail />
        </PrivateRoute>
      ),
    },

    // Site Visit Area
    {
      path: "/site-visit-request",
      element: (
        <PrivateRoute>
          <RequestSiteVisit />
        </PrivateRoute>
      ),
    },
    {
      path: "/site-visit-list",
      element: (
        <PrivateRoute>
          <SiteVisitList />
        </PrivateRoute>
      ),
    },

    // Support Ticket Area
    {
      path: "/create-support-ticket",
      element: (
        <PrivateRoute>
          <CreateSupportTicket />
        </PrivateRoute>
      ),
    },
    {
      path: "/support-ticket-list",
      element: (
        <PrivateRoute>
          <SupportTicketlists />
        </PrivateRoute>
      ),
    },
    {
      path: "/support-ticket-list/chat",
      element: (
        <PrivateRoute>
          <ChatBox />
        </PrivateRoute>
      ),
    },

    // Reports
    {
      path: "/business-detail",
      element: (
        <PrivateRoute>
          <RecursiveBusiness />
        </PrivateRoute>
      ),
    },
    {
      path: "/payout-report",
      element: (
        <PrivateRoute>
          <MyPayoutReport />
        </PrivateRoute>
      ),
    },
    {
      path: "/annual-incentive",
      element: (
        <PrivateRoute>
          <MyAnnualIncentive />
        </PrivateRoute>
      ),
    },
    {
      path: "/founder-club",
      element: (
        <PrivateRoute>
          <MyFounderClub />
        </PrivateRoute>
      ),
    },
    {
      path: "/gst-report",
      element: (
        <PrivateRoute>
          <MyGSTReport />
        </PrivateRoute>
      ),
    },
    {
      path: "/tds-report",
      element: (
        <PrivateRoute>
          <MyTDSReport />
        </PrivateRoute>
      ),
    },
    //
    {
      path: "/dashboard",
      element: (
        <PrivateRoute>
          <DashboardBisiness />
        </PrivateRoute>
      ),
    },
    {
      path: "/terms-conditions",
      element: (
        <>
          <TermsAndConditions />
        </>
      ),
    },
    {
      path: "/gallery/:slug",
      element: (
        <PrivateRoute>
          <ProjectGallery />
        </PrivateRoute>
      ),
    },
    {
      path: "/changePassword",
      element: (
        <PrivateRoute>
          <ChangePasswordForm />
        </PrivateRoute>
      ),
    },
  ];
  return [
    ...commonRoutes,
    ...(appType === "Business" ? businessRoutes : ecommerceRoutes),
  ];
};
function App({ pathname }) {
  const appType = useSelector((state) => state?.uiReducers?.appType);
  document.documentElement.style.setProperty(
    "--themeColor",
    appType === "Business" ? "#222843" : "#7B3A00",
  );
  const router = React.useMemo(
    () => createBrowserRouter(getRoutes(appType)),
    [appType],
  );

  useEffect(() => {}, [appType]);

  if (!appType) {
    return <Loader />;
  }
  return (
    <>
      {<CenteredSettings />}
      <RouterProvider router={router} hydrateFallbackElement={<Loader />} />
    </>
  );
}
export default App;
